import { Action, createReducer, on } from '@ngrx/store';
import * as CsatActions from './csat.actions';
import { IState } from './csat.declarations';

const INITIAL_STATE = {
  lastAnswerDate: null,
  questionsList: null
};

const reducer = createReducer<IState>(
  INITIAL_STATE,
  on(CsatActions.getQuestionsInfoSuccess, (state, { lastAnswerDate, questionsList}) => ({
    ...state,
    lastAnswerDate: lastAnswerDate,
    questionsList: questionsList
  }))
);

export function CsatReducer(state: IState, action: Action) {
  return reducer(state, action);
}
